/**
 * cn() — RetroUI's class-merge helper (vendored verbatim from
 * Logging-Studio/RetroUI `lib/utils.ts`). Combines clsx (conditional class
 * composition) with tailwind-merge (resolves conflicting Tailwind utilities).
 */
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
